import React from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { Menu, Layout } from 'antd'
import classNames from 'classnames'
import Icon from '../../../system/Auth/img/bloo-x-white.png'
import Logo from '../../../system/Auth/img/logo-dark.svg'

import store from 'store'
import { find } from 'lodash'
import style from './style.module.scss'
import Common from 'services/common'
import RouteAccess from 'services/route_access'

const mapStateToProps = ({ menu, settings, user }) => ({
  menuData: menu.menuData,
  isMenuCollapsed: settings.isMenuCollapsed,
  isMobileView: settings.isMobileView,
  isMobileMenuOpen: settings.isMobileMenuOpen,
  isMenuUnfixed: settings.isMenuUnfixed,
  isMenuShadow: settings.isMenuShadow,
  leftMenuWidth: settings.leftMenuWidth,
  menuColor: settings.menuColor,
  logo: settings.logo,
  role: user.role,
  selectedPage: store.get('app.menu.selectedKeys'),
  selectedCluster: user.selectedCluster,
  selectedScope: user.selectedScope,
})
@withRouter
@connect(mapStateToProps)
class MenuLeft extends React.Component {
  state = {
    selectedKeys: store.get('app.menu.selectedKeys') || [],
    openedKeys: store.get('app.menu.openedKeys') || [],
  }
  UNSAFE_componentWillMount() {
    this.setSelectedKeys(this.props)
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.isMenuCollapsed && !newProps.isMobileView) {
      this.setState({
        openedKeys: [],
      })
    }
    this.setSelectedKeys(newProps)
  }

  setSelectedKeys = props => {
    const { menuData } = this.props
    const flattenItems = (items, key) =>
      items.reduce((flattenedItems, item) => {
        flattenedItems.push(item)
        if (Array.isArray(item[key])) {
          return flattenedItems.concat(flattenItems(item[key], key))
        }
        return flattenedItems
      }, [])
    const selectedItem = find(flattenItems(menuData, 'children'), ['url', props.location.pathname])
    this.setState({
      selectedKeys: selectedItem ? [selectedItem.key] : [],
    })
  }

  onCollapse = (value, type) => {
    const { dispatch, isMenuCollapsed } = this.props
    if (type === 'responsive' && isMenuCollapsed) {
      return
    }

    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'isMenuCollapsed',
        value: !isMenuCollapsed,
      },
    })

    this.setState({
      openedKeys: [],
    })
  }

  onOpenChange = openedKeys => {
    store.set('app.menu.openedKeys', openedKeys)
    this.setState({
      openedKeys,
    })
  }

  handleClick = e => {
    store.set('app.menu.selectedKeys', [e.key])
    this.setState({
      selectedKeys: [e.key],
    })
  }

  generateMenuItems = () => {
    const { menuData = [], role, location } = this.props
    let clusterSelected = JSON.parse(localStorage.getItem('userPayload'))
    const generateItem = item => {
      const { key, title, icon, disabled, count, urlEnd } = item
      // var dummyUrl = typeof url !== 'undefined' ? url.split('/') : []
      var str = Common.getPreURI()
      str += typeof urlEnd !== 'undefined' ? urlEnd : ''
      var finalUrl = str
      if (item.category) {
        return <Menu.ItemGroup key={Math.random()} title={item.title}></Menu.ItemGroup>
      }
      if (finalUrl) {
        return (
          <Menu.Item
            key={key}
            className={
              location.pathname.indexOf(finalUrl) > -1
                ? !(location.pathname.indexOf('/workbook/new') > -1 && icon === 'far fa-book')
                  ? 'topbarSelect'
                  : ''
                : ''
            }
            disabled={disabled}
          >
            {item.target ? (
              <a href={finalUrl} target={item.target} rel="noopener noreferrer">
                <span className={style.title}>{title}</span>
                {count && <span className="badge badge-success ml-2">{count}</span>}
                {icon && <span className={`${icon} ${style.icon} icon-collapsed-hidden`} />}
              </a>
            ) : (
              <Link
                to={finalUrl}
                onClick={() => {
                  if (item.title === 'Find') {
                    localStorage.setItem('dir_path', '/drafts')
                  }
                }}
              >
                <span className={style.title}>{title}</span>
                {count && <span className="badge badge-success ml-2">{count}</span>}
                {icon && <span className={`${icon} ${style.icon} icon-collapsed-hidden`} />}
              </Link>
            )}
          </Menu.Item>
        )
      }
      return (
        <Menu.Item key={key} disabled={disabled}>
          <span className={style.title}>{title}</span>
          {count && <span className="badge badge-success ml-2">{count}</span>}
          {icon && <span className={`${icon} ${style.icon} icon-collapsed-hidden`} />}
        </Menu.Item>
      )
    }

    const generateSubmenu = items =>
      items.map(menuItem => {
        if (menuItem.children) {
          const subMenuTitle = (
            <span key={menuItem.key}>
              <span className={style.title}>{menuItem.title}</span>
              {menuItem.count && <span className="badge badge-success ml-2">{menuItem.count}</span>}
              {menuItem.icon && <span className={`${menuItem.icon} ${style.icon}`} />}
            </span>
          )
          return (
            <Menu.SubMenu title={subMenuTitle} key={menuItem.key}>
              {generateSubmenu(menuItem.children)}
            </Menu.SubMenu>
          )
        }
        return generateItem(menuItem)
      })

    return menuData.map(menuItem => {
      if (menuItem.roles && !menuItem.roles.includes(role)) {
        return null
      }
      if (menuItem.children) {
        const subMenuTitle = (
          <span key={menuItem.key}>
            <span className={style.title}>{menuItem.title}</span>
            {menuItem.count && <span className="badge badge-success ml-2">{menuItem.count}</span>}
            {menuItem.icon && <span className={`${menuItem.icon} ${style.icon}`} />}
          </span>
        )
        return (
          <Menu.SubMenu title={subMenuTitle} key={menuItem.key}>
            {generateSubmenu(menuItem.children)}
          </Menu.SubMenu>
        )
      }
      return generateItem(menuItem)
    })
  }

  render() {
    const { selectedKeys, openedKeys } = this.state
    const {
      isMobileView,
      isMenuCollapsed,
      menuColor,
      leftMenuWidth,
      isMenuUnfixed,
      isMenuShadow,
      selectedCluster,
      selectedScope,
    } = this.props
    const menuSettings = isMobileView
      ? {
          width: leftMenuWidth,
          collapsible: false,
          collapsed: false,
          onCollapse: this.onCollapse,
        }
      : {
          width: leftMenuWidth,
          collapsedWidth: 56,
          collapsed: isMenuCollapsed,
          onCollapse: this.onCollapse,
          breakpoint: 'lg',
        }

    const menu = this.generateMenuItems()
    return (
      <>
        {!window.location.toString().includes('/reportlink/') && (
          <Layout.Sider
            {...menuSettings}
            className={classNames(`${style.menu}`, {
              [style.white]: menuColor === 'white',
              [style.gray]: menuColor === 'gray',
              [style.dark]: menuColor === 'dark',
              [style.unfixed]: isMenuUnfixed,
              [style.shadow]: isMenuShadow,
            })}
            style={{
              transitionProperty: 'all',
              transitionDuration: '0.2s',
              transitionTimingFunction: 'ease',
              transitionDelay: '0s',
            }}
          >
            <div
              className={style.menuOuter}
              style={{
                width: isMenuCollapsed && !isMobileView ? 56 : leftMenuWidth,
                height: isMobileView || isMenuUnfixed ? 'calc(100% - 64px)' : 'calc(100% - 110px)',
                overflowY: 'auto',
                overflowX: 'hidden',
              }}
            >
              <div className={style.logoContainer}>
                <div
                  className={style.logo}
                  style={{ justifyContent: isMenuCollapsed ? 'center' : 'flex-start' }}
                >
                  {selectedScope &&
                  selectedScope.scope_id !== undefined &&
                  RouteAccess.SEC_ANALYSTS_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES).includes(
                    localStorage.getItem('UserAcc'),
                  ) ? (
                    <Link
                      to={
                        selectedCluster
                          ? '/' +
                            selectedCluster.clusterId +
                            '/' +
                            selectedScope.scope_id +
                            '/home/'
                          : '/home/'
                      }
                    >
                      <img
                        style={{ height: '22px' }}
                        src={isMenuCollapsed ? Icon : Logo}
                        alt={Common.productName}
                      />
                    </Link>
                  ) : (
                    <>
                      <img
                        style={{ height: '22px' }}
                        src={isMenuCollapsed ? Icon : Logo}
                        alt={Common.productName}
                      />
                    </>
                  )}
                  <div className={style.name}></div>
                </div>
              </div>
              <div style={{ top: '10px' }}>
                <Menu
                  onClick={this.handleClick}
                  selectedKeys={selectedKeys}
                  openKeys={openedKeys}
                  onOpenChange={this.onOpenChange}
                  mode="inline"
                  className={style.navigation}
                  inlineIndent="15"
                >
                  {menu}
                </Menu>
              </div>
            </div>
          </Layout.Sider>
        )}
      </>
    )
  }
}

export default MenuLeft
